import React from 'react';

const UserGuidePage = () => {
  return <></>;
};

export default UserGuidePage;
